module.exports = __webpack_public_path__ + "static/pexels-coffee-contact-email-hands-4831-compressor-c1fbec37360c20de6f951f5c368c08ed.jpg";